import React from "react";
import { MotionConfig } from "framer-motion";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppRoutes from "./routes/AppRoutes"; // adjust if needed

// Single app-level toast container (slide-in/fade-out) -- replaces the
// ~40 per-page <ToastContainer/> instances that used to duplicate this,
// each page's toast() calls still reach this one since react-toastify
// targets whichever container is mounted.
const App = () => {
  return (
    <MotionConfig reducedMotion="user">
      <AppRoutes />
      <ToastContainer position="top-right" autoClose={3000} transition={Slide} />
    </MotionConfig>
  );
};

export default App;